import { useDispatch, useSelector } from "react-redux"
import { enqueueRandomAlbum, setEditingQueue, shuffleQueue, stopRandomMode, toggleRandomRepeatMode } from "../../actions/randomModeActions"
import { Button, IconButton, Tooltip } from "@mui/material"
import { anyLongDisablingProcess } from "../../reducers/disablingProcesses"
import { getRandomModeActive, getRandomRepeatMode, isEditingQueue } from "../../reducers/randomMode"
import { Edit, Refresh, Repeat, RepeatOne, Shuffle, Stop } from "@mui/icons-material"
import { RANDOM_REPEAT_MODES } from "../../utils/constants/enumConstants"
import { useManageRepeatQueueMode } from "../../hooks/randomMode/useManageRepeatQueueMode"

export const ShuffleButton = ({emptyQueue}) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(shuffleQueue())
    }

    return (
        <Tooltip title={!emptyQueue && "Shuffle queue"}>
            <span>
                <IconButton disabled={emptyQueue} size="small" onClick={onClick}>
                    <Shuffle />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export const RepeatModeButton = ({emptyQueue}) => {
    const repeatMode = useSelector(getRandomRepeatMode);
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(toggleRandomRepeatMode())
    }

    useManageRepeatQueueMode();

    return (
        <Tooltip title={!emptyQueue && repeatMode}>
            <span>
                <IconButton disabled={emptyQueue} size="small" onClick={onClick}>
                    {
                        repeatMode === RANDOM_REPEAT_MODES.album ? 
                        <RepeatOne color='primary' /> : 
                        <Repeat color={repeatMode !== RANDOM_REPEAT_MODES.off ? 'primary' : 'default'} />
                    }
                </IconButton>
            </span>
        </Tooltip>
    )
}

export const EditModeButton = ({emptyQueue}) => {
    const editingMode = useSelector(isEditingQueue);

    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(setEditingQueue(!editingMode));
    }

    return (
        <Tooltip title={!emptyQueue && "Edit queue"}>
            <span>
                <IconButton disabled={emptyQueue} size="small" onClick={onClick}>
                    <Edit color={editingMode ? 'primary' : 'default'} />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export const StopModeButton = ({emptyQueue}) => {
    const randomModeActive = useSelector(getRandomModeActive);

    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(stopRandomMode());
    }

    return (
        <Tooltip title={!emptyQueue && (randomModeActive ? "Stop random mode and reset queue" : "Reset queue")}>
            <span>
                <IconButton disabled={emptyQueue} size="small" onClick={onClick}>
                    { randomModeActive ? <Stop /> : <Refresh /> } 
                </IconButton>
            </span>
        </Tooltip>
    )
}

export const StartQueueButton = () => {
    const disabled = useSelector(anyLongDisablingProcess);

    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(enqueueRandomAlbum());
    }

    return (
        <Button disabled={disabled} variant="contained" onClick={onClick}>
            Add first random album
        </Button>
    )
}